import { handleEnterDown } from 'common/handlers';
import { Button, Flex, Header, Input, TextContent } from 'components';
import { useEffect, useState } from 'react';
import * as bi from 'react-bootstrap-icons';

interface IProps {
  source: string;
  sendedAt: Date;
  onContinueClick: (code: string) => void;
  onSendAgainClick: () => void;
  onBackClick: () => void;
}

function FramePhoneCode(props: IProps) {
  const [code, setCode] = useState<string>('');
  const [secondsToMessage, setSecondsToMessage] = useState<number>(90);

  useEffect(() => {
    setSecondsToMessage(90);
    const allowedAt = Math.floor(props.sendedAt.getTime() / 1000) + 90;

    const timer = setInterval(() => {
      const currentSeconds = Math.floor(Date.now() / 1000);
      const timeToAllow = allowedAt - currentSeconds;
      setSecondsToMessage(timeToAllow < 0 ? 0 : timeToAllow);
    }, 1000);

    return () => {
      clearInterval(timer);
    };
  }, [props.sendedAt]);

  const isValidCode = code.trim().length === 4;

  const handleResendClick = () => {
    if (secondsToMessage <= 0) {
      props.onSendAgainClick();
    }
  };

  const handleBackClick = () => props.onBackClick();

  const handleRegisterClick = () => {
    if (isValidCode) {
      props.onContinueClick(code.trim());
    }
  };

  const handleCodeKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => handleEnterDown(e, handleRegisterClick);

  return (
    <Flex
      direction='column'
      gap={20}
    >
      <TextContent align='center'>Введите код подтверждения регистрации, который был отправлен на телефон</TextContent>
      <TextContent align='center'>
        <b>{props.source}</b>
      </TextContent>

      <Input
        type='text'
        placeholder='1234'
        label='Код подтверждения'
        icon={<bi.Alphabet />}
        value={code}
        onChange={setCode}
        onKeyDown={handleCodeKeyDown}
      />

      <Flex
        direction='column'
        gap={5}
      >
        <Button
          color='red'
          disabled={!isValidCode}
          onClick={handleRegisterClick}
        >
          Регистрация
        </Button>
        <Button
          color='transparent-red'
          size='small'
          disabled={secondsToMessage > 0}
          onClick={handleResendClick}
        >
          Отправить ещё раз {secondsToMessage > 0 && <span>(через {secondsToMessage} сек.)</span>}
        </Button>
        <Button
          color='transparent-blue'
          size='small'
          onClick={handleBackClick}
        >
          Назад
        </Button>
      </Flex>
    </Flex>
  );
}

export default FramePhoneCode;
